import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=31c628ac&"
import script from "./xiangqing.vue?vue&type=script&lang=js&"
export * from "./xiangqing.vue?vue&type=script&lang=js&"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=31c628ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports